import { Input } from 'design-system';

type DashboardNameInputProps = {
  ariaLabel?: string;
  error?: unknown;
  maxLength?: number;
  value: string;
  onBlur?: () => void;
  onChange: (value: string) => void;
  onFocus?: () => void;
};

const getErrorMessage = (error: unknown) => {
  const firstError = Array.isArray(error) ? error[0] : error;
  if (typeof firstError === 'string') return firstError;
  if (
    typeof firstError === 'object' &&
    firstError !== null &&
    'message' in firstError &&
    typeof firstError.message === 'string'
  ) {
    return firstError.message;
  }
  return undefined;
};

export const DashboardNameInput = ({
  ariaLabel,
  error,
  maxLength,
  value,
  onBlur,
  onChange,
  onFocus
}: DashboardNameInputProps) => {
  const errorMessage = getErrorMessage(error);

  return (
    <div className='grid min-w-0 gap-1'>
      <Input
        aria-label={ariaLabel}
        aria-invalid={Boolean(errorMessage)}
        maxLength={maxLength}
        value={value ?? ''}
        onBlur={onBlur}
        onChange={event => {
          onChange(event.target.value);
        }}
        onFocus={onFocus}
      />
      {errorMessage && (
        <p
          className='text-xs text-destructive'
          role='alert'
        >
          {errorMessage}
        </p>
      )}
    </div>
  );
};
